var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-01
 * @brief EHP DashBoard - e-HC 평균 점수 컴포넌트
 *
 ********************************************************************/
import React, { useState, useEffect, useRef } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import { loadingBoxState, urlState } from "../../../recoil/menuState";
// ex-utils
import ECharts from 'echarts-for-react';
// utils
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
import * as CUTIL from "../../../utils/commUtils";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
/**
* @brief EHP DashBoard - e-HC 평균 점수 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
//component
const LCONST_NUM_CARDWSIZE = 450;
function EhcAverageScore(props) {
    //trans, ref, navigate
    const navigate = useNavigate();
    const mobileRef = useRef(null);
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const [isLoadingBox, setRecoilIsLoadinBox] = useRecoilState(loadingBoxState);
    //props
    const selTree = props.selTree;
    const colCount = props.colCount;
    //
    const [isMobile, setIsMobile] = useState(false);
    const [ehcAverage, setEhcAverage] = useState({
        "totalAvgScore": 0,
        "alarmStatus": "",
        "alarmMessage": "",
        "groupAvgScore": [
        /*{"checkGroupId":1,"checkGroupName":"사용연수","value":10.432693,"safeScore":17},
        {"checkGroupId":2,"checkGroupName":"운전이력","value":16.914482,"safeScore":17},
        {"checkGroupId":3,"checkGroupName":"설치환경","value":9.248998,"safeScore":17},
        {"checkGroupId":4,"checkGroupName":"부하조건","value":13.289713,"safeScore":17},
        {"checkGroupId":5,"checkGroupName":"유지보수","value":12.627465,"safeScore":17}*/
        ]
    });
    //
    useEffect(() => {
        // Mobile 체크
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if (!CUTIL.isnull(mobileTag)) {
                //clog("XX WIDTH : " + mobileTag.clientWidth);
                if ((mobileTag.clientWidth <= LCONST_NUM_CARDWSIZE)) {
                    setIsMobile(true);
                }
                else {
                    setIsMobile(false);
                }
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (mobileRef.current) {
            //clog("XX WIDTH : " + mobileRef.current.clientWidth);
            if ((mobileRef.current.clientWidth <= LCONST_NUM_CARDWSIZE)) {
                setIsMobile(true);
            }
        }
    }), 100, [ehcAverage]);
    //
    const stepList = [
        { "id": 0, "stepDisp": "Basic", "stepVal": "BASIC" },
        { "id": 1, "stepDisp": "Premium", "stepVal": "PREMIUM" },
        { "id": 2, "stepDisp": "Advanced", "stepVal": "ADVANCED" },
    ];
    const [step, setStep] = useState(stepList[0]);
    useEffect(() => {
        setStep(stepList[0]);
    }, [selTree]);
    // option 선택 시  값 변경 액션
    function selectOptionStep(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        setStep(JSON.parse(optionData));
    }
    // ECahrt , data 반시계 반향으로 적용
    const chartDefaultVal = {
        color: [
            "rgba(144, 159, 183, 0.5)",
            "#FF6781",
            "#5B71EF", // VCB 평균 점수 Data
            // "#FF917C"
        ],
        // 차트 하단 정보
        legend: {
            bottom: "bottom",
            icon: "circle",
            align: "auto",
        },
        // 점수 나오게하는 곳 
        tooltip: {
            position: ['50%', '50%'],
            backgroundColor: "#2A2C2F",
            textStyle: {
                color: "#FFFFFF",
                fontSize: 13
            },
            /*formatter: function (params) {
              return `${params.data.value} EA`
            },*/
        },
        //grid: {"left":"3%", "right":"3%", "top":"10%", "bottom":"10%"},
        radar: //[
        {
            indicator: [
                { name: '부하조건', color: "black" },
                { name: '운전이력', color: "black" },
                { name: '설치환경', color: "black" },
                { name: '사용연수', color: "black" },
                { name: '유지보수', color: "black" },
            ],
            // 배경 간격
            splitNumber: 1,
            // 차트 max  
            radius: 100,
            // startAngle: 90,
            //radar 사이 box style
            splitArea: {
                areaStyle: {
                    color: ["#FFF", "#FFF"],
                },
            },
            // 구분선 색상
            axisLine: {
                lineStyle: {
                    // color: '#2A2C2F'
                    color: "#C3CBD8",
                },
            },
            // 배경 라인 색상
            splitLine: {
                lineStyle: {
                    color: "#C3CBD8",
                },
            },
            // 배경 font
            axisName: {
                fontWeight: 500,
                fontFamily: "Noto Sans KR",
                fontSize: 16
            }
        },
        //],
        series: //[
        {
            type: "radar",
            emphasis: {
                lineStyle: {
                    width: 4,
                },
            },
            data: [
                {
                    value: [20, 20, 20, 20, 20],
                    name: "배점",
                    symbol: "circle",
                    symbolSize: 6,
                },
                {
                    value: [0, 0, 0, 0, 0],
                    name: "평균점수",
                    symbol: "circle",
                    symbolSize: 6,
                    areaStyle: {
                        opacity: 0.1
                    },
                },
                {
                    value: [0, 0, 0, 0, 0],
                    name: "안전점수",
                    symbol: "circle",
                    symbolSize: 6,
                    areaStyle: {
                        opacity: 0.1
                    },
                },
            ],
        },
        //],
    };
    const [chartVal, setChartVal] = useState(chartDefaultVal);
    function handleChartVal(val) {
        clog("AVG : " + JSON.stringify(val));
        if (val.groupAvgScore.length <= 0) {
            setChartVal(chartDefaultVal);
            return;
        }
        let indicators = [];
        val.groupAvgScore.map((score) => {
            indicators.push({ name: score.checkGroupName, color: "black" });
        });
        const pointVals = Object.assign(Object.assign({}, chartVal.series.data[0]), { value: val.groupAvgScore.map((score) => 20) });
        const averageVals = Object.assign(Object.assign({}, chartVal.series.data[1]), { value: val.groupAvgScore.map((score) => parseFloat(score.value)) });
        const saftyVals = Object.assign(Object.assign({}, chartVal.series.data[2]), { value: val.groupAvgScore.map((score) => parseFloat(score.safeScore)) });
        setChartVal(Object.assign(Object.assign({}, chartVal), { radar: Object.assign(Object.assign({}, chartVal.radar), { indicator: indicators, axisName: { fontWeight: 500, fontFamily: "Noto Sans KR", fontSize: (isMobile) ? 12 : 16 } }), series: Object.assign(Object.assign({}, chartVal.series), { data: [pointVals, averageVals, saftyVals] }) }));
    }
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/maindashboard/ehcaverage?zoneId=${selTree.zone.zoneId}&stepName=${step.stepVal}`,
        appQuery: {
        /*"zoneId" : selTree.zone.zoneId,
        "spgList" : spg.spgVal*/
        },
        userToken: userInfo.loginInfo.token,
        watch: selTree.zone.zoneId + step.stepVal,
    });
    useEffect(() => {
        setRecoilIsLoadinBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (retData) {
            setRecoilIsLoadinBox(false);
            //clog("IN INFOCARS : EHC AVERAGE : RES : " + JSON.stringify(retData.body));
            if (retData.codeNum == CONST.API_200) {
                setEhcAverage(retData.body);
                handleChartVal(retData.body);
            }
        }
    }, [retData, isMobile]);
    const chartWidth = window.innerWidth / (8 / colCount) * 0.781;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "box__header", ref: mobileRef },
            React.createElement("p", { className: "box__title" }, "e-HC \uD3C9\uADE0 \uC810\uC218"),
            React.createElement("div", { className: "box__etc" },
                React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectOptionStep) },
                    React.createElement("div", { className: "selected" },
                        React.createElement("div", { className: "selected-value" }, step.stepDisp),
                        React.createElement("div", { className: "arrow" })),
                    React.createElement("ul", null, stepList.map((step, idx) => (React.createElement("li", { key: `li_${idx.toString()}`, className: "option", "data-value": JSON.stringify(step) }, step.stepDisp))))))),
        (ehcAverage.groupAvgScore.length <= 0)
            ? React.createElement("div", { className: "box__body" },
                React.createElement("div", { className: "top mt-20" },
                    React.createElement("div", { className: `ehc__info ehc-${(step.stepVal === "ADVANCED") ? "a" : (step.stepVal === "PREMIUM") ? "p" : "b"}` },
                        React.createElement("p", { className: "ehc__name" },
                            selTree.company.companyName,
                            " ",
                            (selTree.zone.zoneId.length > 0) ? selTree.zone.zoneName : ""))),
                React.createElement("p", { className: "txt-ready" },
                    React.createElement("span", null,
                        React.createElement("strong", null, step.stepDisp),
                        " \uC9C4\uB2E8\uC810\uAC80\uC744 \uC9C4\uD589\uD558\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.")))
            : React.createElement("div", { className: "box__body" },
                React.createElement("div", { className: "top mt-80" },
                    React.createElement("div", { className: `ehc__info ehc-${(step.stepVal === "ADVANCED") ? "a" : (step.stepVal === "PREMIUM") ? "p" : "b"}` },
                        React.createElement("p", { className: "ehc__name" },
                            selTree.company.companyName,
                            " ",
                            (selTree.zone.zoneId.length > 0) ? selTree.zone.zoneName : "")),
                    React.createElement("div", { className: "ehc__detail" },
                        React.createElement("div", { className: "result__txt" },
                            React.createElement("p", { className: `tit ${(ehcAverage.alarmStatus === "SAFETY") ? "" : (ehcAverage.alarmStatus === "WARNING_SCORE") ? "caution" : "caution"}` },
                                React.createElement("span", null, "\uC885\uD569\uC810\uC218")),
                            React.createElement("p", { className: "score" }, ehcAverage.totalAvgScore),
                            React.createElement("p", { className: "txt" }, ehcAverage.alarmMessage)))),
                React.createElement("div", { className: "bottom" },
                    React.createElement("div", { className: "chart", style: { "width": "100%", "margin": "0 auto" } },
                        React.createElement("div", { id: "radar", style: { "height": "300px" } },
                            React.createElement(ECharts, { option: chartVal, className: "bottom ehc__chart h300", style: { "width": `${chartWidth}px` } })))))));
}
export default EhcAverageScore;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
